import { FlagCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function FlagFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <FlagCommandList multiselect selected={selection} onSelect={onSelect} />
}
